/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponse,
  PharmacyDirectory,
} from '../models';
import {
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    PharmacyDirectoryFromJSON,
    PharmacyDirectoryToJSON,
} from '../models';

export interface GetPharmaciesRequest {
    name?: string;
    limit?: number;
}

/**
 * 
 */
export class PharmaciesApi extends runtime.BaseAPI {

    /**
     * Returns all Pharmacies (Roles: physician, admin, patient)
     */
    async getPharmaciesRaw(requestParameters: GetPharmaciesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PharmacyDirectory>>> {
        const queryParameters: any = {};

        if (requestParameters.name !== undefined) {
            queryParameters['name'] = requestParameters.name;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/pharmacies`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PharmacyDirectoryFromJSON));
    }

    /**
        Request Config Getter
     */
    getPharmaciesRequestOptionsRaw(requestParameters: GetPharmaciesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        const queryParameters: any = {};

        if (requestParameters.name !== undefined) {
            queryParameters['name'] = requestParameters.name;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/pharmacies`,
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Returns all Pharmacies (Roles: physician, admin, patient)
     */
    async getPharmacies(requestParameters: GetPharmaciesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PharmacyDirectory>> {
        const response = await this.getPharmaciesRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
